<div class="text-white flex flex-col h-full w-full p-3 overflow-hidden masterparent px-5">
  <div class="flex p-3 pl-1">
    @for (item of navHeaders; track $index) {
    <div class="flex flex-col items-center" (click)="setCurrentUI(item.val)">
      <span class="mx-4 text-[16px] leading-[16px] cursor-pointer" ngClass="{{
            curTab == item.val ? 'text-white ' : 'text-sub-header-colorss'
          }}">{{ item.label | translate }}</span>
    </div>
    }
  </div>
  <div class="flex justify-between dark:bg-dimGrey flex-wrap h-fit p-3 pl-7">
    <div class="flex sm:justify-start md:justify-between items-center flex-wrap md:gap-x-3 w-fit">
      @for (item of plantInfo; track item.icon) {
      <div class="flex justify-between flex-wrap items-center mr-0.5">
        @if (item.icon) {
        <img src="{{ item.icon }}" class="mr-1 h-3 w-3" alt="" />
        }
        <span class="text-sm font-medium m-0">{{ item.description }}{{ " (" + item.count + ")" }}</span>
      </div>
      } @empty {
      Empty list of users
      }
    </div>
    <div class="flex flex-wrap">
      <div class="flex mr-5">
        <div class="relative flex items-center cursor-pointer" (appClickableDirective)="toggleCustomize()">
          <img src="../../../../assets/svg/customize.svg" alt="Customize" />

          @if (customize) {
          <div>
            <div
              class="w-[200px] z-10 p-1 overflow-auto sm:h-fit sm:max-h-[38rem] lg:w-unset bg-slateGrey absolute top-[25px] sm:right-2 rounded-lg flex flex-col"
              (click)="$event.stopPropagation()">
              <span class="font-medium text-center mt-2">Select Display Columns</span>
              <div class="flex flex-col justify-center">
               
                @for (item of filterColumns; track $index) {
  <div class="flex p-1">
    <input
      id="filterCheckbox-{{ $index }}"
      type="checkbox"
      [attr.aria-label]="headerKeyMap[item.name]"
      [checked]="item.isSelected"
      [(ngModel)]="item.isSelected"
      (ngModelChange)="toggleFilterCheckBox($event)"
    />
 
    <span class="ml-2">
      {{ headerKeyMap[item.name] }}
    </span>
  </div>
}
                <div class="flex px-2 filterbutton sm:w-fit lg:w-full justify-between">
                  <div>
                    <button class="flex-grow w-14 cursor-pointer" (click)="cancelFilter($event)">
                      Cancel
                    </button>
                  </div>
                  <div>
                    <button class="flex-grow w-14 cursor-pointer" (click)="confirmHandler($event)">
                      Confirm
                    </button>
                  </div>
                  <div>
                    <button class="flex-grow w-14 cursor-pointer" (click)="resetHandler($event)">
                      Reset
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="relative flex items-center cursor-pointer ml-3">
        <app-excel-download [columns]="columns" [apiResponse]="apiResponse" [headerStyling]="headerStyling"
          [fileName]="fileName" [sheetName]="sheetName">
        </app-excel-download>
      </div>
      <div class="flex justify-around items-center"></div>
    </div>
  </div>

  <div class="text-white h-full max-w-full flex flex-col pc">
    @if (curTab == "solar") {
    <div class="table-container">

      <table>
        <thead class="bg-btTh">
          <tr>
            <th>
              <div class="flex">
                <input class="" type="checkbox" id="selectAllPlants" aria-label="Select All Plants" [checked]="selectAll" [(ngModel)]="selectAll"
                  (change)="toggleSelectAll()" />
                <span class="ml-6 flex justify-center items-center text-sm font-medium whitespace-nowrap">Plant
                  Name</span>
              </div>
            </th>
            @for (item of solarPlantListHeaders; track $index) {
            <th scope="col" class="text-sm font-medium whitespace-nowrap cursor-pointer"
              (appClickableDirective)="sortData(item)">
              @if (item === "plantHealth") {
              <div class="flex flex-row justify-center">
                <span>{{ headerKeyMap[item] }}</span>
                <img src="../../../../assets/images/infoicon.svg" class="h-[14px] px-2" alt="Info"
                  matTooltip="{{ getTooltipContent(item) }}" matTooltipClass="tooltipClass" />
              </div>
              } @else {
              {{ headerKeyMap[item] }}
              }
            </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr class="cursor-pointer relative" *ngFor="let item of solarPlantManagementData"
            (appClickableDirective)="loadNewTab(item.plantId ? item.plantId : '',item.plantName?item.plantName:'')">
            @if(item.plantName){<td class="text-center abc">
              <div class="flex">
                <input type="checkbox" class="" [checked]="item.isSelected" id="solarCheckbox" aria-label="solarCheckbox" [(ngModel)]="item.isSelected"
                  (change)="toggleCheckBox()" (appClickableDirective)="$event.stopPropagation()" />
                <div class="flex flex-col items-start ml-6 text-xs font-medium whitespace-nowrap">
                  <span class="text-white"> {{ item.plantName }}</span>
                  <span class="mt-2 text-[11px] font-normal text-start">
                    Last Updated: {{ item.lastUpdated }}</span>
                </div>
              </div>

            </td>}
            @if (item.status) {
            <td class="text-center">
              @if (item.status === "Online") {
              <img src="../../../../assets/svg/green.svg" class="h-3 w-3" alt="online" />
              } @else {
              <img src="../../../../assets/svg/red.svg" class="h-3 w-3" alt="offline" />
              }
            </td>}
            @if(item.dataloggerSN){
            <td class="text-center text-xs">
              {{ item.dataloggerSN }}
            </td>}
            @if (item.modelName) {
            <td class="text-xs whitespace-nowrap text-center">
              {{ item.modelName }}
            </td>}
            @if (item.inverterRating) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.inverterRating }}
            </td>}
            @if (item.solarPVInstalled) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.solarPVInstalled }}
            </td>}
            @if (item.solarPower) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.solarPower }}
            </td>}
            @if (item.todayGeneration) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.todayGeneration }}
            </td>}
            @if (item.lifetimeGeneration) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.lifetimeGeneration }}
            </td>}
            @if (item.plantHealth) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.plantHealth }}
            </td>}
            @if (item.alert) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.alert }}
            </td>}
            @if (item.customerName) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.customerName }}
            </td>}
            @if (item.savings != null && item.savings >= '0') {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.savings }}
            </td>}
            @if (item.roi != null && item.roi >= 0) {
            <td class="text-center text-xss whitespace-nowrap">
              {{ item.roi }} %
            </td>}
            @if (item.treesPlanted != null && item.treesPlanted >= 0) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.treesPlanted }}
            </td>}
            @if (item.co2Saved) {
            <td class="text-center text-xs whitespace-nowrap" >
              {{ item.co2Saved }}
            </td>}
            @if (item.coalNotburned) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.coalNotburned }}
            </td>}
            @if (item.dataloggerSignalStrength) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.dataloggerSignalStrength }}
            </td>}
            @if (item.plantCreationDate) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.plantCreationDate }}
            </td>}
            @if (item.totalDays !== undefined && item.onlineDays !== undefined) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.onlineDays + "/" + item.totalDays }}
            </td>}
          </tr>
        </tbody>
      </table>
    </div>
    }

    @if (curTab == "non_solar") {
    <div class="table-container">
      <table>
        <thead class="cczzz">
          <tr>
            <th>
              <div class="flex">
                <input class="" type="checkbox" id="nonSolarCheckbox" aria-label="nonSolarCheckbox" [checked]="selectAll" [(ngModel)]="selectAll"
                  (change)="toggleSelectAll()" />
                <span class="ml-6 flex justify-center items-center text-sm font-semibold">Plant Name</span>
              </div>
            </th>
            @for (item of nonSolarPlantListHeaders; track $index) {
            <th scope="col" class="text-sm font-medium whitespace-nowrap cursor-pointer" (appClickableDirective)="sortData(item)">
              {{ headerKeyMap[item] }}
            </th>
            }
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of non_solarPlantManagementData" class="cursor-pointer"
            (appClickableDirective)="loadNewTab(item.plantId ? item.plantId : '',item.plantName?item.plantName:'')">
            @if(item.plantName){
            <td class="text-start abc">
              <div class="flex">
                <input type="checkbox" id="plantCheckbox" type="checkbox" aria-label="plantCheckbox" [checked]="item.isSelected" [(ngModel)]="item.isSelected"
                  (change)="toggleCheckBox()" (appClickableDirective)="$event.stopPropagation()" />
                   
                <div class="flex flex-col items-start ml-6 text-xs font-medium whitespace-nowrap">
                  <span class="text-white"> {{ item.plantName }}</span>
                  <span class="mt-2 text-[11px] font-normal text-start">
                    Last Updated: {{ item.lastUpdated }}</span>
                </div>
              </div>
            </td>}
            @if (item.status) {
            <td class="text-center label-xs font-normal whitespace-nowrap">
              @if (item.status === "Online") {
              <img src="../../../../assets/svg/green.svg" class="h-3 w-3" alt="" />
              } @else {
              <img src="../../../../assets/svg/red.svg" class="h-3 w-3" alt="" />
              }
            </td>}
            @if (item.dataloggerSN) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.dataloggerSN }}
            </td>}
            @if(item.modelName){
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.modelName }}
            </td>}
            @if(item.inverterRating){
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.inverterRating }}
            </td>}
            @if (item.plantHealth) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.plantHealth }}
            </td>}
            @if (item.batteryVoltage) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.batteryVoltage }}
            </td>}
            @if (item.batteryState) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.batteryState }}
            </td>}
            @if (item.powerCutDuration) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.powerCutDuration }}
            </td>}
            @if (item.noofPowerCut != null && item.noofPowerCut >= 0) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.noofPowerCut }}
            </td>}
            @if (item.totalBackupCapacity) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.totalBackupCapacity }}
            </td>}
            @if(item.currentBackupCapacity){
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.currentBackupCapacity }}
            </td>}
            @if (item.alert) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.alert }}
            </td>}
            @if (item.customerName) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.customerName }}
            </td>}
            @if (item.gridVoltage) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.gridVoltage }}
            </td>}
            @if (item.plantCreationDate) {
            <td class="text-center text-xs font-normal whitespace-nowrap">
              {{ item.plantCreationDate }}
            </td>}
            @if ( item.totalDays !== undefined && item.onlineDays !== undefined) {
            <td class="text-center text-xs whitespace-nowrap">
              {{ item.onlineDays + "/" + item.totalDays }}
            </td>}
          </tr>
        </tbody>
      </table>
    </div>
    }

    <div class="flex justify-center items-center mt-2 w-[full] m-1">
      <div class="flex items-center">
        <div class="flex min-w-[25%] space-x-2 justify-around">
          <button class="bg-btTh h-6 w-8" (click)="getPrevPage()" [disabled]="
              (this.prevSolarPage < 0 && this.curTab == 'solar') ||
              (this.prevNonsolarPage < 0 && this.curTab == 'non_solar')
            ">
            <app-arrow-left-icon />
          </button>
          <button (click)="getNextPage()" class="bg-btTh h-6 w-8" [disabled]="displayNext == true">
            <app-angle-right-icon class="text-white" />
          </button>
        </div>

        <div class="flex flex-wrap p-1 rounded-full ml-3">

          <select class="w-[144px] text-btnGrey pl-1.5 bg-bgSelect btns" [(ngModel)]="pageSize" id="pageSizeSelect" aria-label="Items-per-page"
            (change)="togglePageSize($event)" #pageSizeHandler>
            <option value="20">20/page</option>
            <option value="50">50/page</option>
            <option value="100">100/page</option>
          </select>
          
        </div>
      </div>
    </div>
  </div>
</div>